import { useMediaQuery } from 'react-responsive'
import { breakpoints } from '../styles/breakpoints'

export const useBreakpoint = () => {
  const isXs = useMediaQuery({ maxWidth: breakpoints.xs - 1 })
  const isSm = useMediaQuery({
    minWidth: breakpoints.xs,
    maxWidth: breakpoints.sm - 1,
  })
  const isMd = useMediaQuery({
    minWidth: breakpoints.sm,
    maxWidth: breakpoints.md - 1,
  })
  const isLg = useMediaQuery({
    minWidth: breakpoints.md,
    maxWidth: breakpoints.lg - 1,
  })
  const isXl = useMediaQuery({
    minWidth: breakpoints.lg,
    maxWidth: breakpoints.xl - 1,
  })
  const isXxl = useMediaQuery({
    minWidth: breakpoints.xl,
    maxWidth: breakpoints.xxl - 1,
  })
  const isUhd = useMediaQuery({ minWidth: breakpoints.xxl })

  return {
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    isXxl,
    isUhd,
    current: isXs
      ? 'xs'
      : isSm
        ? 'sm'
        : isMd
          ? 'md'
          : isLg
            ? 'lg'
            : isXl
              ? 'xl'
              : isXxl
                ? 'xxl'
                : 'uhd',
  }
}
